import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';

declare var require: any;
import * as _ from 'lodash-es';


@Component({
  selector: 'app-worker-checkin',
  templateUrl: './worker-checkin.component.html',
  styleUrls: ['./worker-checkin.component.scss']
})
export class WorkerCheckinComponent implements OnInit {

  @Input() worker:any;

  @Output() refreshWorker = new EventEmitter();

  check_in_times: { value: number; name: string }[] = [];
  alert_times = Utils.getAlertTimes();
  alert_repeat = Utils.getAlertReminder();
  whatsapp_options = Utils.getWhatsAppOptions();

  callRepeats:any;
  smsRepeats:any;
  numOfRepeats:any;
  tooManyRepeats = false;

  call_reminders = false;
  sms_reminders = false;

  formGroup = new FormGroup({
    check_in_freq: new FormControl('',[Validators.required,]),
    call_alert: new FormControl('',[]),
    sms_alert: new FormControl('',[]),
    email_alert: new FormControl('',[]),
    call_alert_repeat: new FormControl('',[]),
    sms_alert_repeat: new FormControl('',[]),
    whatsapp: new FormControl<string | number>('',[])
  })

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {
    this.setupCheckInTimes();
    this.setForm();
    //console.log('this worker',this.worker);
  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  setForm(){
    this.formGroup.setValue({
      check_in_freq: this.worker.check_in_freq,
      call_alert: this.worker.call_alert,
      sms_alert: this.worker.sms_alert,
      email_alert: this.worker.email_alert,
      call_alert_repeat: this.worker.call_alert_repeat,
      sms_alert_repeat: this.worker.sms_alert_repeat,
      whatsapp: this.okService.hasFeature('whatsapp') ? this.worker.whatsapp : 0
    });

    //console.log(this.okService.settings);

    if(!this.okService.hasFeature('whatsapp')){
      this.formGroup.controls['whatsapp'].setValue(0);
    }

    if(this.okService.settings.arc_on){
      this.formGroup.controls['call_alert'].disable();
      this.formGroup.controls['sms_alert'].disable();
      this.formGroup.controls['sms_alert_repeat'].disable();
      this.formGroup.controls['call_alert_repeat'].disable();
      this.formGroup.controls['email_alert'].disable();
    }
    if(this.worker.status?.working){
      this.formGroup.controls['check_in_freq'].disable();
    }

    if(!this.okService.hasMonitorWorkerAccess('workers','update')){
      this.formGroup.controls['check_in_freq'].disable();
      this.formGroup.controls['call_alert'].disable();
      this.formGroup.controls['sms_alert'].disable();
      this.formGroup.controls['sms_alert_repeat'].disable();
      this.formGroup.controls['call_alert_repeat'].disable();
      this.formGroup.controls['email_alert'].disable();
      this.formGroup.controls['whatsapp'].disable();
    }

    this.hideCallReminders();
    this.hideSMSReminders();

  }

  setupCheckInTimes(){
    this.check_in_times = Utils.getCheckinTimes(this.okService.settings?.id);

    let check_in_time = _.find(this.check_in_times,{'value':this.worker.check_in_freq}); 

    // If ARC then remove 30mins
    if(this.okService.settings.arc_on){
      this.check_in_times.splice(1, 1); // 2nd parameter means remove one item only
    }
    
    if(!check_in_time){
      this.check_in_times[0] = {"value":this.worker.check_in_freq,"name":this.worker.check_in_freq+" mins"}
      this.check_in_times.unshift({"value":6000,"name":"No Timer"});
    }

  }

  submitForm(){
    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values:any = this.formGroup.getRawValue();
        if(!this.okService.hasFeature('whatsapp')){
          values.whatsapp = 0;
        }
        //console.log(values);

        this.okService.put("workers/"+this.worker.id,values)
        .subscribe((data) => {

          this.worker = data.body;

          //console.log("worker",this.worker);
          //console.log("monitors",this.worker.monitors);
          //console.log("vehicle",this.worker.vehicle_id);
          this.setForm();
          this.refreshWorker.emit();

          this.okService.setAlert(this.transloco.translate("The worker has been updated"),"success");

        });

      }

    return false;
  }

  setDevice(device:string){

    if(this.okService.hasMonitorWorkerAccess('workers','update')){

      let values = this.formGroup.value
      //console.log(values);
  
      this.okService.put("workers/"+this.worker.id,{device:device})
      .subscribe((data) => {
  
        this.worker = data.body;
        this.refreshWorker.emit();
  
        this.okService.setAlert(this.transloco.translate("The worker has been updated"),"success");
  
      });
      
    }

  }

  totalRepeats(){
    if(!this.okService.isFromAdmin()){
      
      if(this.formGroup.value.call_alert != '0' && this.formGroup.value.sms_alert != '0'){

        this.callRepeats = this.formGroup.value.call_alert_repeat! + 1;
        this.smsRepeats = this.formGroup.value.sms_alert_repeat! + 1;
        this.numOfRepeats = this.callRepeats + this.smsRepeats;

        if(this.numOfRepeats > 4){
          this.tooManyRepeats = true;
        }else{
          this.tooManyRepeats = false;
        }

      }
    }

  }

  // Hide the call reminders if the call alert is none
  hideCallReminders(){
    if(this.formGroup.get('call_alert')?.value){
      this.call_reminders = true;
    }else{
      this.call_reminders = false;
    }
  }

  // Hide the sms reminders if the sms alert is none
  hideSMSReminders(){
    if(this.formGroup.get('sms_alert')?.value){
      this.sms_reminders = true;
    }else{
      this.sms_reminders = false;
    }
  }

}
